import { ReactElement, useState } from "react";
import {
  Button,
  Checkbox,
  Col,
  Drawer,
  Form,
  Input,
  Row,
  Select,
  TimePicker,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DrawerFooter } from "../../components/GlobalStyles";
import { EDIT_COURT_REQUEST } from "../../redux/constants";
import { getAuthState } from "../../redux/selectors";

const { Option } = Select;
const { useForm } = Form;

type Props = {
  visible: boolean;
  onClose: () => void;
  court: any;
};

export function EditCourtDrawer({
  visible,
  onClose,
  court,
}: Props): ReactElement {
  const dispatch = useDispatch();
  const { branchId } = useParams<{ branchId: string }>();
  const { currentUser } = useSelector(getAuthState);
  const [form] = useForm();
  const { t } = useTranslation();
  const onFinish = (values: any) => {
    const updatedFormValue = {
      ...values,
      currentUser,
      branchId,
      courtId: court.courtId,
    };
    dispatch({
      type: EDIT_COURT_REQUEST,
      payload: updatedFormValue,
    });
    form.resetFields();
    onClose();
  };

  const onFinishFailed = (errorInfo: any) => {
    // eslint-disable-next-line no-console
    console.log("Failed:", errorInfo);
  };

  return (
    <Drawer
      title={t("court.edit_court")}
      width={720}
      onClose={onClose}
      visible={visible}
      bodyStyle={{ paddingBottom: 80 }}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={{
          name: court.name,
          place: court.place,
          description: court.description,
        }}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="name"
              label={t("court.name")}
              rules={[{ required: true, message: t("court.name_placeholder") }]}
            >
              <Input placeholder={t("court.name_placeholder")} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="place"
              label={t("court.court_place")}
              rules={[
                { required: true, message: t("court.court_place_placeholder") },
              ]}
            >
              <Select placeholder={t("court.court_place_placeholder")}>
                <Option value="indoor">{t("court.indoor")}</Option>
                <Option value="outdoor">{t("court.outdoor")}</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="description"
              label={t("court.description")}
              rules={[
                {
                  required: true,
                  message: t("court.description_placeholder"),
                },
              ]}
            >
              <Input.TextArea
                rows={4}
                placeholder={t("court.description_placeholder")}
              />
            </Form.Item>
          </Col>
        </Row>
        <DrawerFooter>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            {t("common.cancel")}
          </Button>
          <Button type="primary" htmlType="submit">
            {t("common.submit")}
          </Button>
        </DrawerFooter>
      </Form>
    </Drawer>
  );
}
